import globalConfig from 'react-global-configuration';
import queryString from 'query-string';
import { credentials } from '@shootsta/client-auth';

import getCurrentUserId from './getCurrentUserId';

const IFRAME_ID = 'download_iframe';

export default function (queryParams) {
  const serviceEndpoint = globalConfig.get('serviceEndpoint');
  const hasCurrentUserId = !!getCurrentUserId();

  const { videoStatus } = queryParams;

  const downloadApiRoute = !hasCurrentUserId && videoStatus === 'APPROVED' ?
  'downloads/publicVideoAsset' :
  'downloads';

  const { token } = credentials.get();

  const paramsWithToken = {
    ...queryParams,
    ...(token ? { t: token } : null),
    videoStatus: undefined
  };

  const downloadUrlWithQueryParams = `${serviceEndpoint}export/${downloadApiRoute}?${queryString.stringify(paramsWithToken, { arrayFormat: 'comma' })}`;

  const iframeElement = document.getElementById(IFRAME_ID);

  if (iframeElement) {
    iframeElement.src = downloadUrlWithQueryParams;

    return;
  }

  const newIframe = document.createElement('iframe');

  newIframe.setAttribute('id', IFRAME_ID);
  newIframe.setAttribute('style', 'display:none');

  // $FlowFixMe
  document.body.appendChild(newIframe);

  const appendedIframe = document.getElementById(IFRAME_ID);

  if (!appendedIframe) {return;}

  appendedIframe.src = downloadUrlWithQueryParams;
}